const IfEmpty = () => {
  return (
    <div className="sm:min-h-screen sm:h-full md:h-full w-full flex justify-center items-center bg-slate-100">
      <div className="flex justify-center items-center flex-col gap-5">
        <div className="w-[100px] h-[100px] rounded-full flex justify-center items-center bg-white shadow-md">
          <i className="fa-regular fa-comments text-4xl text-violet-500"></i>
        </div>
        <h5 className="text-base text-slate-500 shadow-md rounded-full px-5 py-1 bg-white">
          Start Conversation
        </h5>
      </div>
    </div>
  );
};

export default IfEmpty;
